module.exports = __webpack_public_path__ + "static/widgetInAction-ed7e9e65f485bdced268adb966a7e5e9.gif";